import * as React from 'react';
import { connect } from 'react-redux';
import { navigate } from '~/router';
import { createRouteNodeSelector } from 'redux-router5';

import PaycodeListHeader from '../../components/codes/PaycodeListHeader';

import { getPaycodeFilter, paycodeFilterParams } from '../../services/qsfilters';
import { setPaycodeCurrentPage } from '~/apps/support/actions/paycodes';


class PaycodeHeader extends React.Component<any, any> {
  render() {
    const { route: { params }, dispatch } = this.props;
    const filter = getPaycodeFilter(params);

    return (
      <PaycodeListHeader
        onFilter={(q) => {
          filter.q = q;
          navigate('support.paycodes', paycodeFilterParams(filter));
          dispatch(setPaycodeCurrentPage(0));
        }}
        filter={filter}
        onCreate={() => navigate('support.paycodes.create')} />
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};

export default connect(createRouteNodeSelector('receiver.admin.transactions'), mapDispatchToProps)(PaycodeHeader) as any;
